import { render, staticRenderFns } from "./CreateShortcut.vue?vue&type=template&id=fe17fdb6&scoped=true&"
import script from "./CreateShortcut.vue?vue&type=script&lang=js&"
export * from "./CreateShortcut.vue?vue&type=script&lang=js&"
import style0 from "./CreateShortcut.vue?vue&type=style&index=0&id=fe17fdb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe17fdb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VRow})
